import React, { useRef, useState } from 'react';
//import { QrReader } from 'react-qr-reader';
import { Scanner } from '@yudiel/react-qr-scanner';
// navigate, useNavigate
import { Button } from 'primereact/button';

export const QrScaner = (props) => {
    //const [data, setData] = useState('No result');

    const { onScane, onClose } = props;
    const containerRef = useRef(null);
    const hasScannedRef = useRef(false);
    const [paused, setPaused] = useState(false);

    const captureFrame = async () => {
        const video = containerRef.current?.querySelector('video');

        if (!video || !video.videoWidth || !video.videoHeight) {
            return null;
        }

        const canvas = document.createElement('canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        const context = canvas.getContext('2d');
        if (!context) {
            return null;
        }

        context.drawImage(video, 0, 0, canvas.width, canvas.height);

        const blob = await new Promise((resolve) => {
            canvas.toBlob(resolve, 'image/jpeg', 0.92);
        });

        if (!blob) {
            return null;
        }

        return {
            file: new File([blob], `barcode-scan-${Date.now()}.jpg`, { type: 'image/jpeg' }),
            capturedAt: new Date().toISOString(),
            width: canvas.width,
            height: canvas.height
        };
    };

    const handleScan = async (result) => {
        if (!result[0] || hasScannedRef.current) {
            return;
        }

        hasScannedRef.current = true;
        setPaused(true);

        const scanValue = result[0].rawValue;
        const snapshot = await captureFrame();

        onScane(scanValue, snapshot);

        window.setTimeout(() => {
            hasScannedRef.current = false;
            setPaused(false);
        }, 600);
    };

    return (
        <div ref={containerRef}>
            {/* <QrReader
                            constraints={{
                                facingMode: 'environment'
                            }}
                            onResult={(result, error) => {
                                if (!!result) {
                                    //setData(result?.text);
                                    onScane(result?.text);
                                }

                                if (!!error) {
                                    console.info(error);
                                }
                            }}
                            style={{ width: '100%' }}
                        /> */}
            <Scanner formats={['code_128', 'code_39', 'code_93', 'codabar', 'ean_13', 'ean_8', 'itf', 'qr_code']} onError={(err) => console.error(err)} paused={paused} onScan={handleScan} />
            <p className="text-center text-400 mb-2">
                Usmerite kameru ka Barkod kodu
                <br />
                <Button
                    label=" Ne može da skenira? Unesi ručno"
                    onClick={() => {
                        hasScannedRef.current = false;
                        setPaused(false);
                        onClose?.();
                    }}
                    className="btn btn-sm btn-outline-secondary mt-2"
                ></Button>
            </p>
        </div>
    );
};
